import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import LayoutGrid from "../shared/grid"
import Breakpoints from "../shared/breakpoints"
import Img from "gatsby-image"
import { T } from "../shared/typography.styles"

const Container = styled.div`
  padding: 32px 0 64px;

  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

const CMSImage = styled(Img)`
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    grid-row: span 3;
  }
`

const Title = styled.h2`
  ${T.sm.h2.semiBold}
  color: var(--slate);
  grid-column: 1 / -1;
  align-self: start;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h2.semiBold}
    text-align: center;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2.semiBold}
    text-align: left;
    grid-column: -6 / -2;
    margin-top: 0;
  }
`

const Description = styled.p`
  ${T.sm.body.regular}
  color: var(--body-text-grey);
  grid-column: 1 / -1;
  align-self: start;
  margin-top: 24px;
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
    grid-column: 2 / -2;
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
    grid-column: -6 / -1;
    text-align: left;
  }
`

const Highlight = styled.span`
  color: var(--burnt-orange);
  font-weight: 500;
`

export default function Component(props) {
  const query = useStaticQuery(graphql`
    query {
      imacImage: file(
        relativePath: { eq: "1_SOLUTIONS/Indoor Mapping/cms_imac.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Container>
      <LayoutGrid>
        <CMSImage
          fluid={query.imacImage.childImageSharp.fluid}
          alt="Computer displaying the Mappedin Content Management System"
          imgStyle={{ objectFit: "contain" }}
        />
        <Title>
          Manage 3D Indoor Maps and Navigation <Highlight>from One Simple Place</Highlight>
        </Title>
        <Description>
          Mappedin is the leading provider of indoor 3D mapping software. Our
          platform provides powerful indoor navigation experiences and the
          Mappedin CMS serves as the foundational layer. A source of truth for
          your property maps, the CMS creates collaboration across organizations
          to maintain accurate data in real-time.
        </Description>
        <Description>
          A powerful indoor intelligence mapping platform, Mappedin provides you
          with a cutting-edge mapping system and intuitive wayfinding apps. A
          source of truth for your property maps, our Map Editor creates
          collaboration across organizations to maintain accurate maps and
          location data in real-time.
        </Description>
      </LayoutGrid>
    </Container>
  )
}
